'use client';

import { hasCldImage, TypePageCaseStudy } from '@fm-nx/contentful-types';
import CaseStudyItem from '../case-study-item/case-study-item';
import LinkWrapper from '../link-wrapper/link-wrapper';

type FeaturedCaseStudyPropTypes = {
    pageCaseStudy: TypePageCaseStudy<'WITHOUT_UNRESOLVABLE_LINKS'>;
    mode?: 'dark' | 'light';
};

export const FeaturedCaseStudy = (props: FeaturedCaseStudyPropTypes) => {
    const { mode = 'light', pageCaseStudy } = props;
    const { summary, title, year } = pageCaseStudy.fields;
    const imageCloudinary = hasCldImage(pageCaseStudy.fields.heroImage?.fields)
        ? pageCaseStudy.fields.heroImage?.fields.cloudinaryMedia[0]
        : null;

    if (!imageCloudinary) return null;
    return (
        <LinkWrapper page={pageCaseStudy}>
            <CaseStudyItem
                summary={summary}
                title={title}
                imageUrl={imageCloudinary.public_id}
                year={year}
                mode={mode}
            />
        </LinkWrapper>
    );
};

export default FeaturedCaseStudy;
